import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { createCalculatorReducer } from './calculator';
import { CalculatorInitialState } from 'apps/calculator/types';

export const createReducer = ({
  initialState,
}: {
  initialState: CalculatorInitialState;
}) =>
  combineReducers({
    form: formReducer,
    calculator: createCalculatorReducer(initialState),
  });
